import { redux } from "./redux";

export { LinkedRecords } from "./LinkedRecords";

export {
  loadingLinkedRecords as refreshLinkedRecords,
  waitLinkedRecords,
} from "./redux/actions";

export type { LinkedRecord } from "./domain/LinkedRecord";
export { LinkedRecordType } from "./domain/LinkedRecordType";

export const moduleDefinition = {
  module: {
    redux,
  },
};
